(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    // task item component
    module.directive('task', ['$compile', function ($compile) {
        var directive = {
            restrict: 'E',
            scope: {
                task: '='
            },
            //replace: true,
            templateUrl: '/app/tasks/templates/task.template.html',
            controller: 'TaskController',
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };
        return directive;

        function link(scope, element) {
            // if element is clicked -> open task-reactions

            // if abort-button is clicked
            element.on('click', function (e) {

                // has been created the element ?
                var tra = element.find('task-reaction-add')[0];
                if (typeof tra !== 'undefined') {
                    tra = null;
                    return false;
                }

                // create the element
                var el = $compile("<task-reaction-add class='move' task='vm.task'></task-reaction-add>")(scope);
                element.find('task-reaction-list').append(el);
                el = null;

                return false;
            });


            // on destroy
            scope.$on('$destroy', function () {
                element.off('click');
            });

        }

    }]);

})();